import { render, staticRenderFns } from "./newQrcode.vue?vue&type=template&id=7becc55c"
import script from "./newQrcode.vue?vue&type=script&lang=js"
export * from "./newQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports